<template>
    <HeaderComp />
    <HeroSection />
    <ScrollingBanner />
    <SocialMediaSection />
    <NewsCarousel />
    <OpeningHours />
    <ServicesSection />
    <FitnessTrialOfferComp />
    <AboutSection />
    <GallerySection />
    <ContactSection />
    <FooterComp />
    <CookieConsentBanner />
</template>

<script>
import { defineAsyncComponent } from 'vue'
import HeaderComp from '@/components/home/HeaderComp.vue'
import HeroSection from '@/components/home/HeroSection.vue'

const ScrollingBanner      = defineAsyncComponent(() => import('@/components/home/ScrollingBanner.vue'))
const SocialMediaSection   = defineAsyncComponent(() => import('@/components/home/SocialMediaSection.vue'))
const NewsCarousel         = defineAsyncComponent(() => import('@/components/home/news/NewsCarousel.vue'))
const OpeningHours         = defineAsyncComponent(() => import('@/components/home/OpeningHours.vue'))
const ServicesSection      = defineAsyncComponent(() => import('@/components/home/ServicesSection.vue'))
const FitnessTrialOfferComp = defineAsyncComponent(() => import('@/components/home/FitnessTrialOfferComp.vue'))
const AboutSection         = defineAsyncComponent(() => import('@/components/home/AboutSection.vue'))
const GallerySection       = defineAsyncComponent(() => import('@/components/home/GallerySection.vue'))
const ContactSection       = defineAsyncComponent(() => import('@/components/home/ContactSection.vue'))
const FooterComp           = defineAsyncComponent(() => import('@/components/home/FooterComp.vue'))
const CookieConsentBanner  = defineAsyncComponent(() => import('@/components/cookiebanner/CookieConsentBanner.vue'))

export default {
  name: 'HomePage',
  components: {
    HeaderComp,
    HeroSection,
    ScrollingBanner,
    SocialMediaSection,
    NewsCarousel,
    OpeningHours,
    ServicesSection,
    FitnessTrialOfferComp,
    AboutSection,
    GallerySection,
    ContactSection,
    FooterComp,
    CookieConsentBanner,
  },
}
</script>
